/**
 * FEAT-018: 파일 미리보기 모달 공통 컴포넌트
 */
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Translate as t } from '../../config/Translate';
import { isImage, isPdf, downloadWithName } from '../../utils/filePreview';

const FilePreviewModal = ({ show, file, url, onClose }) => (
  <Modal show={show} onHide={onClose} size="lg" centered>
    <Modal.Header>
      <h5 className="modal-title" style={{ fontSize: '0.95rem' }}>{file?.name}</h5>
    </Modal.Header>
    <Modal.Body className="text-center p-2">
      {file && isImage(file.name) && url && (
        <img src={url} alt={file.name}
          style={{ maxWidth: '100%', maxHeight: '70vh' }} />
      )}
      {file && isPdf(file.name) && url && (
        <iframe src={url}
          sandbox="allow-same-origin"
          referrerPolicy="no-referrer"
          style={{ width: '100%', height: '70vh', border: 'none' }}
          title={file.name} />
      )}
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-outline-dark btn-sm"
        onClick={() => { url && downloadWithName(url, file?.name || 'download'); }}>
        <ion-icon name="download-outline"></ion-icon> {t('common.button.download') || 'Download'}
      </button>
      <button className="btn btn-dark btn-sm"
        onClick={onClose}>{t('common.button.close') || 'Close'}</button>
    </Modal.Footer>
  </Modal>
);

export default FilePreviewModal;
